(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen2/assets/javascripts/my-bets-route.js') >= 0) return;  svs.modules.push('/modules/matchen2/assets/javascripts/my-bets-route.js');
"use strict";

const {
  ProtectedRoute
} = svs.components.lbUtils.protectedRoute;
const {
  Route,
  Switch
} = ReactRouterDOM;
const {
  tipsenLazy
} = svs.components.tipsen.tipsenLazy;
const {
  TipsenModuleGameUrl
} = svs.components.sport.tipsenShared;
const {
  RouteMyBetsWagerFallbackMatchen
} = svs.components.tipsen.modularBase; 

const LazyRouteMyBets = tipsenLazy('route-my-bets', () => svs.matchen2.components.RouteMyBets, {
  fallback: () => React.createElement("div", null, "RouteMyBets laddar...")
});
const LazyRouteMyBetsWager = tipsenLazy('route-my-bets-wager', () => svs.matchen2.components.routeMyBetsWager.RouteMyBetsWager, {
  fallback: RouteMyBetsWagerFallbackMatchen
});
const allowedRoles = ['Player', 'CustomerService'];
const MyBetsRoute = () => React.createElement(ProtectedRoute, {
  roles: allowedRoles
}, React.createElement(Switch, null, React.createElement(Route, {
  component: LazyRouteMyBetsWager,
  path: "/".concat(TipsenModuleGameUrl.MY_BETS, "/:wagerId(\\d+)")
}), React.createElement(Route, {
  component: LazyRouteMyBets
})));
setGlobal('svs.matchen2.MyBetsRoute', MyBetsRoute);

 })(window);